import React from 'react';

const SpeakingIndicator = ({ speakingUser, isCallConnected, otherParticipantName }) => {
  if (!isCallConnected) {
    return (
      <div className="flex items-center gap-2 text-zinc-400">
        <span className="text-2xl">💬</span>
        <div>
          <div className="text-sm font-medium text-white">Ready to Connect</div>
          <div className="text-xs">
            Click "Call {otherParticipantName}" to begin
          </div>
        </div>
      </div>
    );
  }

  if (speakingUser) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-orange-500/20 rounded-full animate-pulse-glow">
        <span className="text-3xl animate-bounce">🎙️</span>
        <div>
          <div className="text-sm text-orange-400 font-semibold">
            {speakingUser.name} speaking...
          </div>
          <div className="text-xs text-orange-300/70">
            Live transcription active
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-zinc-400">
      <span className="text-2xl">💬</span>
      <div>
        <div className="text-sm font-medium text-white">Call in Progress</div>
        <div className="text-xs">
          Start speaking to see transcription
        </div>
      </div>
    </div>
  );
};

export default SpeakingIndicator;
